module.exports = __webpack_public_path__ + "img/10855_L.f9896cc5.png";